export function getRedemptionMetrics(inventory = {}) {
  const available = inventory.redemption_metrics_available === true;
  const delivered = count(inventory.delivered_codes ?? inventory.assigned_codes);
  const requested = count(inventory.requested_codes);
  const orderRedemptionCodes = count(
    inventory.order_redemption_codes ?? inventory.redeemed_codes
  );
  const codeReleasedCodes = count(
    inventory.code_released_codes ?? inventory.released_codes
  );
  const releaseReceived = count(
    inventory.true_redemption_codes ?? inventory.redeemed_release_received_codes
  );
  const unrealizedCodes = hasCount(inventory.unrealized_codes)
    ? count(inventory.unrealized_codes)
    : Math.max(0, codeReleasedCodes - releaseReceived);
  const fulfilled = count(inventory.successfully_released_order_codes);

  return {
    available,
    delivered,
    assigned: delivered,
    requested,
    redeemed: orderRedemptionCodes,
    orderRedemptionCodes,
    codeReleasedCodes,
    unrealizedCodes,
    trueRedemptionCodes: releaseReceived,
    releaseReceived,
    fulfilled,
    orderRedemptionRate: available
      ? rateValue(inventory.order_redemption_rate, orderRedemptionCodes, delivered)
      : null,
    codeReleasedRate: available
      ? rateValue(inventory.code_released_rate, codeReleasedCodes, delivered)
      : null,
    unrealizedRate: available
      ? rateValue(inventory.unrealized_rate, unrealizedCodes, delivered)
      : null,
    trueRedemptionRate: available
      ? rateValue(
          inventory.delivered_true_redemption_rate,
          releaseReceived,
          delivered
        )
      : null,
  };
}

export function formatRate(value) {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) return "N/A";
  return `${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;
}

function rateValue(value, numerator, denominator) {
  const parsed = Number(value);
  if (value !== null && value !== undefined && Number.isFinite(parsed)) return parsed;
  if (denominator <= 0) return null;
  return Math.round((numerator / denominator) * 10000) / 100;
}

function count(value) {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 0;
}

function hasCount(value) {
  return value !== null && value !== undefined && Number.isFinite(Number(value));
}
